import CTASection from "../../../reusableUi/CTA";
import LocationsFAQs from "./LocationsFAQs";
import LocationsGrid from "./LocationsGrid";

export default function ServicesMain() {
  return (
    <main className="space-y-24">
      <LocationsGrid />
      <LocationsFAQs />
      <CTASection />
    </main>
  );
}
